export default __webpack_public_path__ + "static/media/one-maxi.7f6c53ce.mp4";